
    import './styles.scoped.css';
    export default {
  "sticky-notifications": "awsui_sticky-notifications_154bi_u5i3h_9",
  "sticky-notifications-with-background": "awsui_sticky-notifications-with-background_154bi_u5i3h_13",
  "has-notifications-content": "awsui_has-notifications-content_154bi_u5i3h_17"
};
  